module.exports = __webpack_public_path__ + "media/images/emoticons/bottle-a9616deb69ec6e73b81c0a0957427697.gif";